<template>
    <h3 class="text-center mt-4">Thanks for your application</h3>
    <!-- the app does not exist -->
    <div class="" v-if="!this.application">
        <div class="d-grid gap-2 col-6 mx-auto my-3">
            <a class="btn btn-primary" href="/loan">Apply</a>
        </div>
    </div>
    <div v-else>
        <div class="" v-if="this.mustRedirect && this.redirectUrl">
            <h4 class="text-center mt-4">We are loading your results...</h4>
        </div>
        <div v-else>
            <!-- We found a match for the user -->
            <div class="my-5" v-if="this.buyers">
                <!-- Buyers Section -->
                <Buyers :buyers="this.buyers" />

                <!-- Tabs Section -->
                <!-- <Tabs :tabsSettings="this.tabsSettings" title="We can add a title here"> -->
    <!--            <Tabs :tabsSettings="this.tabsSettings" title="">-->
    <!--                <template #tabsOptions>-->
    <!--                    &lt;!&ndash; if we wanna add more options to this section:-->
    <!--                        - add another Tab component-->
    <!--                        - pass a unique name prop-->
    <!--                        - add a <template #new> tag with that same name prop used for the Tab-->
    <!--                            -add tab content within the <template> tag-->
    <!--                    &ndash;&gt;-->
    <!--                    <Tab :tabsSettings="this.tabsSettings" name="score" />-->
    <!--                    &lt;!&ndash; <Tab :tabsSettings="this.tabsSettings" name="pastApplications" prettyName="Past Applications"/> &ndash;&gt;-->
    <!--                    <Tab :tabsSettings="this.tabsSettings" name="account" />-->
    <!--                </template>-->
    <!--                <template #score>-->
    <!--                    <CreditScore :showCreditScore="this.showCreditScore"/>-->
    <!--                </template>-->
    <!--                &lt;!&ndash; past applications &ndash;&gt;-->
    <!--                &lt;!&ndash; <template #pastApplications>-->
    <!--                    <div class="my-5" v-if="this.pastApplications">-->
    <!--                        <h4>Past applications</h4>-->
    <!--                        <div class="mt-3">-->
    <!--                            <div  v-for="(appObject, date, index) in this.pastApplications" :key="index" class="accordion" id="accordionExample">-->
    <!--                                <div class="accordion-item mt-4">-->
    <!--                                    <h2 class="accordion-header" :id="'heading_'+index">-->
    <!--                                    <button @click="activeApplication = index" class="accordion-button" :class="showApplicationElement() == index ? '' : 'collapsed'" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse_'+index" aria-expanded="true" :aria-controls="'collapse_'+index">-->
    <!--                                        {{appObject.created_at}} :   {{appObject.product_name}}-->
    <!--                                    </button>-->
    <!--                                    </h2>-->
    <!--                                    <div :id="'collapse_'+index" class="accordion-collapse collapse" :class="showApplicationElement() == index ? 'show' : ''" :aria-labelledby="'heading_'+index" data-bs-parent="#accordionExample">-->
    <!--                                        <div class="accordion-body">-->
    <!--                                            <div class="mt-2">-->
    <!--                                                <h5>Providers</h5>-->
    <!--                                                <ul class="list-group">-->
    <!--                                                    <li class="list-group-item">Best Lender</li>-->
    <!--                                                    <li class="list-group-item">Second Best Lender</li>-->
    <!--                                                    <li class="list-group-item">A final Lender</li>-->
    <!--                                                </ul>-->
    <!--                                            </div>-->

    <!--                                            <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-3">-->
    <!--                                                <a class="btn btn-primary" id="">Re-apply</a>-->
    <!--                                            </div>-->

    <!--                                        </div>-->
    <!--                                    </div>-->
    <!--                                </div>-->
    <!--                            </div>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </template> &ndash;&gt;-->
    <!--                <template #account>-->
    <!--                    <div class="d-grid gap-2 col-6 mx-auto my-3">-->
    <!--                        <a class="btn btn-primary my-2" :href="this.memberPortalUrl + '/app/dashboard'">Go to Dashboard</a>-->
    <!--                    </div>-->
    <!--                </template>-->
    <!--            </Tabs>-->
            </div>
            <div v-else>
                <!-- NO match -->
                <div class="my-3">
                    <h4 class="text-center">Unfortunately we were unable to match you with a service provider at this time.</h4>
                </div>
                <div class="d-grid gap-2 col-6 mx-auto my-3">
                    <a class="btn btn-primary my-2" href="/loan" target="_blank">Get Your Free Credit Score Now</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CreditScore from '@/components/CreditScore.vue';
import Buyers from '@/components/Buyers.vue';
import Tabs from '@/components/Tabs.vue';
import Tab from '@/components/Tab.vue';

import {portalLogin} from '@/form/helpers/functions.js';

export default {
    name: 'ProcessedApplication',
    components: {
        CreditScore,
        Buyers,
        Tabs,
        Tab,
    },
    props: {
        application: {
            type: Object,
            required: false,
        },
        mustRedirect: {
            type: Boolean,
            required: false,
            default: true
        },
        shouldRequestCreditScore: {
            type: Boolean,
            required: false,
            default: false
        },
        memberPortalUrl: {
            type: String,
            default: 'https://compare.loanscanada.ca'
        },
    },
    data: () => {
        const testData = true;
        let activeApplication = null;

        let tabsSettings = {
            activeTab: 'score'
        };

        return {
            testData,
            activeApplication,
            tabsSettings
        };
    },
    methods: {
        redirectTo(url) {
            window.location.href = url;
        },
        showApplicationElement() {
            // return this.activeApplication ?? 0;
            return this.activeApplication;
        },
    },
    computed: {
        testComputed() {
            return true;
        },
        buyers() {
            return this.application && this.application.buyers && Object.keys(this.application.buyers).length>0 ?
                this.application.buyers : null;
        },
        pastApplications() {
            return this.application && this.application.pastApplications ?
                this.application.pastApplications : null;
        },
        redirectUrl() {
            return this.application && this.application.redirectUrl ?
                this.application.redirectUrl : null;
        },
        showCreditScore() {
            // this covers regular form submission and application coming from session (thank you page)
            return this.shouldRequestCreditScore || (this.application && this.application.shouldRequestCreditScore);
        }
    },
    created() {
        // console.log('ProcessedApplcation created');
    },
    async mounted() {
        // console.log('ProcessedApplcation mounted');
        // console.log(this.application ?? 'no application');

        if( this.mustRedirect && this.redirectUrl ) {
            // this.redirectTo(this.redirectUrl);
            // this is gonna send the user to the loading interstitial page where we load the pixel
            // and then we redirect to the redirectUrl
            this.redirectTo('/redirect');
        }

        // THIS WAS USED TO LOGIN INTO THE PORTAL, COMMENTED OUT CUZ WAS CAUSING ISSUES WITH THE COOKIES/SESSION
        // if(!!this.application && !!this.application.userAuthentication && !!this.application.userAuthentication.status) {
        //     let payload = {
        //         email:this.application.userAuthentication.email ?? '',
        //         password:this.application.userAuthentication.password ?? '',
        //         baseUrl:this.memberPortalUrl
        //     };
        //     await portalLogin(payload);
        // }
    },
    watch: {
    }
};
</script>
